import { useState } from 'react';
import { t } from '@/i18n';
import { setHomePage } from '@/utils/api';
import type { DashboardSummary } from '@/types/dashboard';

interface ConfirmHomePageModalProps {
  dashboard: DashboardSummary;
  onConfirm: () => void;
  onCancel: () => void;
}

export function ConfirmHomePageModal({ dashboard, onConfirm, onCancel }: ConfirmHomePageModalProps) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleConfirm = async () => {
    setLoading(true);
    setError(null);
    try {
      await setHomePage(dashboard.uuid);
      onConfirm();
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Ошибка');
      setLoading(false);
    }
  };

  return (
    <div className="modal show d-block" tabIndex={-1} role="dialog" aria-modal="true">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{t('dashboard.setHomePageTitle')}</h5>
            <button type="button" className="btn-close" onClick={onCancel} disabled={loading} />
          </div>
          <div className="modal-body">
            {error && <div className="alert alert-danger" role="alert">{error}</div>}
            <p>{t('dashboard.setHomePageBody', { title: dashboard.title })}</p>
            <p className="text-muted small">{t('dashboard.setHomePageHint')}</p>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onCancel} disabled={loading}>
              {t('dashboard.cancel')}
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={handleConfirm}
              disabled={loading}
              data-testid="set-home-page-confirm"
            >
              {loading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" />
                  {t('dashboard.saving')}
                </>
              ) : (
                t('dashboard.confirm')
              )}
            </button>
          </div>
        </div>
      </div>
      <div className="modal-backdrop show" onClick={onCancel} style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: -1 }} />
    </div>
  );
}
